import React from "react";
import styled from "styled-components";
import Loader from "shared/components/Loader";

const LoadingWrapper = styled.div`
  background: white;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
`;

const MainLoading = () => {
  return (
    <LoadingWrapper>
      <Loader />
    </LoadingWrapper>
  );
};

export default MainLoading;
